/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { SubscriptionTypeVoModel } from './subscription-type-vo.model';
import { CreditCardDtoModel } from '../credit-card-dto.model';

export class AccountStatusDtoModel extends JSONable {
  subscriptionTypes: SubscriptionTypeVoModel[] | undefined = undefined;
  creditCardDTO: CreditCardDtoModel | undefined = undefined;

  constructor(subscriptionTypes: SubscriptionTypeVoModel[], creditCard: CreditCardDtoModel) {
    super();
    this.subscriptionTypes = subscriptionTypes;
    this.creditCardDTO = creditCard;
  }
}
